import { Box, ColorOptions, convertHexToRGBA, Icon, ModBox, Spacer, Text } from '@jfs/ui-new'
import { useState } from 'react'
import { Animated, Linking, useWindowDimensions } from 'react-native'
import { FlatList } from 'react-native-gesture-handler'
import { helpCenterData } from '../../static/staticData'
import { colors } from '../../util/colors'
import { isMobileWidth } from '../../util/util'

const LinkText = (props) => {
  return (
    <Box onPress={() => Linking.openURL(props.link)} underlayColor="TRANSPARENT">
      <Text color={'PRIMARY'} fontFamily={'jiotype-medium'} fontSize={14} lineHeight={20}>
        {props.text}
      </Text>
    </Box>
  )
}

const RenderSubItem = ({ item, isMobile }: any) => {
  let children = item
  if (typeof children !== 'string') {
    const anchorStart = children.text.indexOf('<a>')
    let anchorEnd = children.text.indexOf('</a>')
    if (anchorEnd === -1) {
      anchorEnd = children.text.length - 4
    }
    if (anchorStart >= 0) {
      const preText = children.text.substring(0, anchorStart)
      const linkText = children.text.substring(anchorStart + 3, anchorEnd)
      const postText = children.text.substring(anchorEnd + 4)
      children = [preText, <LinkText text={linkText} link={children.link} />, postText]
    } else {
      children = children.text
    }
  }
  return (
    <Box flexDirection={'row'} pv={isMobile ? 8 : 12} align={'flex-start'}>
      <Icon id={'ROUND_TICK'} color={colors.HIGHLIGHT as ColorOptions} size={16} />
      <Spacer direction="horizontal" size={8} />
      <Text
        title={item}
        color={isMobile ? 'BLACK_75' : (convertHexToRGBA('#212121', 88) as ColorOptions)}
        fontFamily={'jiotype-medium'}
        fontSize={14}
        lineHeight={20}>
        {children}
      </Text>
    </Box>
  )
}

const RenderItem = ({ item, index, isMobile, selectedIndex, setSelectedIndex }: any) => {
  const [animatedValue] = useState<any>(new Animated.Value(0))
  const isSelected = selectedIndex === index

  const renderSubItem = ({ item }: any) => {
    return <RenderSubItem item={item} isMobile={isMobile} />
  }

  const startAnimation = () => {
    Animated.timing(animatedValue, {
      toValue: isSelected ? 0 : 1000,
      duration: 500,
      useNativeDriver: true,
    }).start(isSelected ? () => setSelectedIndex(-1) : () => {})
  }

  const handlePress = () => {
    if (!isSelected) {
      if (selectedIndex > -1) {
        animatedValue.setValue(0)
      }
      setSelectedIndex(index)
    }
    startAnimation()
  }

  return (
    <Box
      borderTopWidth={index > 0 && isMobile ? 1 : 0}
      borderTopColor={'DISABLED_GREY'}
      ph={16}
      pv={12}
      bg={isSelected && isMobile ? (convertHexToRGBA(colors.HIGHLIGHT, 6) as ColorOptions) : 'WHITE'}>
      <Box
        flexDirection={'row'}
        underlayColor={'TRANSPARENT'}
        onPress={handlePress}
        justify={'space-between'}
        align={'center'}>
        <Text
          title={item.title}
          color={isSelected && !isMobile ? (colors.HIGHLIGHT as ColorOptions) : 'BLACK_21'}
          fontSize={isMobile ? 14 : 16}
          fontFamily={isMobile && isSelected ? 'jiotype-bold' : 'jiotype-medium'}
        />
        <Spacer direction="horizontal" size={8} />
        <Icon
          id={isSelected ? 'ARROW_UP' : 'ARROW_DOWN'}
          color={isSelected || isMobile ? (colors.HIGHLIGHT as ColorOptions) : 'BLACK_21'}
          size={24}
        />
      </Box>
      <Spacer size={isMobile ? 0 : 12} />
      <Animated.View style={{ maxHeight: animatedValue }}>
        <ModBox
          show={isSelected}
          pv={isMobile ? 8 : 12}
          bg={!isMobile ? (convertHexToRGBA(colors.HIGHLIGHT, 4) as ColorOptions) : undefined}
          ph={isMobile ? 0 : 24}>
          <FlatList data={item.subTitles} renderItem={renderSubItem} />
        </ModBox>
      </Animated.View>
    </Box>
  )
}

export const Accordion = ({ type }: { type: any }) => {
  const viewPortWidth = useWindowDimensions()?.width
  const isMobile = isMobileWidth(viewPortWidth)
  const [selectedIndex, setSelectedIndex] = useState(-1)
  const screenH = useWindowDimensions().height

  const renderItem = ({ item, index }: any) => {
    return (
      <RenderItem
        item={item}
        index={index}
        isMobile={isMobile}
        selectedIndex={selectedIndex}
        setSelectedIndex={setSelectedIndex}
      />
    )
  }

  return (
    <Box h={isMobile ? screenH - 320 : undefined}>
      {isMobile && <Spacer size={12} />}
      <Box w={isMobile ? '100%' : '50%'}>
        <FlatList
          data={helpCenterData[type]}
          renderItem={renderItem}
          style={
            isMobile
              ? { maxHeight: screenH - 340, borderWidth: 1, borderRadius: 16, borderColor: '#E0E0E0' }
              : { maxHeight: 500 }
          }
          showsVerticalScrollIndicator={false}
        />
      </Box>
    </Box>
  )
}
